export enum DataTypeEnum {
  string = "text",
  int = "number",
  date = "date",
}
